export default __webpack_public_path__ + "static/media/tosca_ltd.9465c95f.png";